import script from "./RouterButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterButtons.vue?vue&type=script&setup=true&lang=js"

import "./RouterButtons.vue?vue&type=style&index=0&id=a8a47f3a&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8a47f3a"]])

export default __exports__